import React, { useState, useRef, useEffect } from "react";
import { Arrow, Image, Group, Label,Tag, Circle, Text, Arc, Line } from "react-konva";

const Arrow1 = (props) => {
  const {
    dimension,
    stroke,
    strokeWidth,
    onMouseEnter,
    onMouseLeave,
    onClick,
    onArrowClicked,
    index,
    onMouseDown,
    pointerLength,
    pointerWidth,
    showComponents,
    opacity,
    clickedVector,
    initializedIndex
  } = props;
  const [arrowClicked, setArrowClicked] = useState(false);
  const angle = (Math.atan2(dimension.width, dimension.height) * 180) / Math.PI;
  const magnitude = Math.sqrt(
    Math.pow(dimension.width, 2) + Math.pow(dimension.height, 2)
  );
  const reducedMagnitude =
    magnitude - Math.sqrt(2 * Math.pow(strokeWidth - 1, 2));
  const x2 = Math.sin((angle * Math.PI) / 180) * reducedMagnitude;
  const y2 = Math.cos((angle * Math.PI) / 180) * reducedMagnitude;
  const onTouchStart = () => {
    onMouseDown(props);
    onMouseEnter(props);
  };
  const onClickHandler = (evnt) => {
    if(clickedVector.iarrowClicked){
      setArrowClicked(false)
      onArrowClicked({
        arrowClicked:false,
        index
      }); 
      return;
    }
    setArrowClicked(true)
    onArrowClicked({
        arrowClicked:true,
        index
      }); 
  };
  if(dimension.height === 0  && dimension.width === 0){
    return null;
  }
  // console.log('strokeWidth',x2, y2,dimension.height)
  return (
    <Group
      x={0}
      y={0}
      height={dimension.height}
      width={dimension.width}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onTouchEnd={onMouseLeave}
      onTap={onClick}
      
    >
      <Arrow
        points={[0, 0, x2, y2]}
        stroke={stroke}
        strokeWidth={strokeWidth}
        pointerWidth={pointerWidth}
        pointerLength={pointerLength}
        onClick={onClickHandler}
        onArrowClicked={onArrowClicked}
        index={index}
        opacity={opacity}
        fill={stroke}
      />
      {
        showComponents?
        <>
          <Arrow
            points={[0, dimension.height, x2, dimension.height]}
            stroke={stroke}
            dash={[7,4]}
            opacity={opacity}
            strokeWidth={strokeWidth * .5}
          />
          <Arrow
            points={[0, 0, 0, y2]}
            stroke={stroke}
            dash={[7,4]}
            opacity={opacity}
            strokeWidth={strokeWidth * .5}
          />
        </>:
        null
      }
      
    </Group>
  );
};

//finding Quadrant Position for a Vector
export const getQuadrant = (x,y,posX,posY,gridWidthUnit,gridHeightUnit) => {
  let posX1 = parseInt(posX);
  let posY1 = parseInt(posY);
  let gridWidthUnit1 = parseInt(gridWidthUnit);
  let gridHeightUnit1 = parseInt(gridHeightUnit);
  let realOrginx = posX1-(gridWidthUnit1/2); // Calculating Graph Origin for X
  let realOriginy = posY1-(gridHeightUnit1/2); // Calculating Graph Origin for Y
  let quadrant = 0;
  
  if(((x-realOrginx) >= 0) && ((y - realOriginy) >= 0)){
    quadrant = 1;
  }else if(((x-realOrginx) < 0) && ((y - realOriginy) >= 0)){
    quadrant = 2;
  }else if(((x-realOrginx) < 0) && ((y - realOriginy) < 0)){
    quadrant = 3;
  }else if(((x-realOrginx) >= 0) && ((y - realOriginy) < 0)){
    quadrant = 4;
  }else{
    quadrant = 0;
  }
 
  return quadrant;
};

//Calculating Slope Value for a Vector
export const getSlope = (x,y,posX,posY,gridWidthUnit,gridHeightUnit) => {
  let posX1 = parseInt(posX);
  let posY1 = parseInt(posY);
  let gridWidthUnit1 = parseInt(gridWidthUnit);
  let gridHeightUnit1 = parseInt(gridHeightUnit);
  let realOrginx = posX1-(gridWidthUnit1/2); // Calculating Graph Origin for X
  let realOriginy = posY1-(gridHeightUnit1/2);// Calculating Graph Origin for Y
  let slope = (y-realOriginy)/(x-realOrginx)
  slope = isNaN(slope) === true? 0 : slope ;
  return slope;
};

export const overLapSpecialCaseOne = (x1,x2,y1,y2) =>{
  let X1 = parseInt(x1);
  let X2 = parseInt(x2);
  let Y1 = parseInt(y1);
  let Y2 = parseInt(y2);
  if(X1 === 0 && X2 === 0){
    return overLapRuleTwo(Y1,Y2) ? true:false
  }else{
    return false
  }
}

export const overLapSpecialCaseTwo = (x1,x2,y1,y2) =>{
  let X1 = parseInt(x1);
  let X2 = parseInt(x2);
  let Y1 = parseInt(y1);
  let Y2 = parseInt(y2);
  if(Y1 === 0 && Y2 === 0){
    return overLapRuleOne(X1,X2) ? true:false
  }else{
    return false
  }
}

export const overLapSpecialCaseThree = (x1,x2,y1,y2) =>{
  let X1 = parseInt(x1);
  let X2 = parseInt(x2);
  let Y1 = parseInt(y1);
  let Y2 = parseInt(y2);
  if(X1 === 0 && X2 === 0 && Y1 === 0 && Y2 === 0){
    return true
  }else{
    return false
  }
}

export const getAngleDeg = ({x,y,posX,posY,gridWidthUnit,gridHeightUnit}) => {
  let posX1 = parseInt(posX ? posX : 0);
  let posY1 = parseInt(posY ? posY : 0);
  let gridWidthUnit1 = parseInt(gridWidthUnit ? gridWidthUnit : 10);
  let gridHeightUnit1 = parseInt(gridHeightUnit ? gridHeightUnit : 10);
  let realOrginx = posX1-(gridWidthUnit1/2); // Calculating Graph Origin for X
  let realOriginy = posY1-(gridHeightUnit1/2); // Calculating Graph Origin for Y
  let direction=Math.atan2((y-realOriginy),(x-realOrginx))*180/Math.PI;
  if(direction<0){
    direction=360-Math.abs(direction)
  }
  return direction;
}


const overLapRuleOne = (x1,x2) =>{
  let X1 = parseInt(x1);
  let X2 = parseInt(x2);
  return (X1 * X2 > 0 ? true:false)
}

const overLapRuleTwo = (y1,y2) =>{
  let Y1 = parseInt(y1);
  let Y2 = parseInt(y2);
  return (Y1 * Y2 > 0 ? true:false)
}

const overLapRuleThree = (x1,x2,y1,y2) =>{
  let X1 = Math.abs(parseInt(x1));
  let X2 = Math.abs(parseInt(x2));
  let Y1 = Math.abs(parseInt(y1));
  let Y2 = Math.abs(parseInt(y2));
  return ((X1 / Y1) === (X2/Y2) ? true:false)
}

//For finding two vectors overlapped or not
export const checkTwoVectorOverlap = (x1,y1,x2,y2) =>{
  return overLapRuleThree(x1,y1,x2,y2) && overLapRuleTwo(y1,y2) && overLapRuleOne(x1,x2)
}


//finding length for a Vector
export const calculateMagnitude = ({x,y,posX,posY,gridWidthUnit,gridHeightUnit}) => {
  let posX1 = parseInt(posX ? posX : 0);
  let posY1 = parseInt(posY ? posY : 0);
  let gridWidthUnit1 = parseInt(gridWidthUnit ? gridWidthUnit : 10 );
  let gridHeightUnit1 = parseInt(gridHeightUnit ? gridHeightUnit : 10);
  let realOrginx = posX1-(gridWidthUnit1/2); // Calculating Graph Origin for X
  let realOriginy = posY1-(gridHeightUnit1/2); // Calculating Graph Origin for Y
  return Math.sqrt(Math.pow(x-realOrginx,2)+Math.pow(y-realOriginy,2))
};

const Vector = React.forwardRef(
  ({
    x,
    y,
    posX,
    posY,
    latexImage,
    color,
    magX,
    magY,
    stepSize,
    stage,
    onVectorClicked,
    onArrowClicked,
    onVectorMouseDown,
    onDragEnd,
    index,
    onDragStart,
    groupRef,
    stepDeg,
    angleOptions,
    width,
    height,
    readOnly = false,
    _showLabel,
    showComponents,
    clickedVector,
    checkBoxVector,
    labelRule,
    gridWidthUnit,
    gridHeightUnit,
    Nvector,
    strokeWidth,
    initializedIndex
  },ref) => {
    //console.log("stage1", color)
    // Note: magX and magY are swapped in Arrow, because the whole group is rotated by 270 degrees, to being the origin of y axis to the bottom.
    // Always multiply mag with Step Size before passing it to the vector component
    const [origin, setOrigin] = useState({
      x: posX * stepSize,
      y: (height - posY) * stepSize,
    });

    const [dimension, setDimension] = useState({ width: magY, height: magX });

    const [showLabel, setShowLabel] = useState(false);

    const [opacity,setOpacity] = useState(1);

    useEffect(()=>{
      setShowLabel(_showLabel);
    },[_showLabel]);

    useEffect(()=>{
      if(clickedVector?.iarrowClicked && clickedVector?.clickedVectorIndex !== index){
        setOpacity(0.2);
      }else{
        setOpacity(1);
      }
    },[clickedVector])

    useEffect(()=>{
      if(checkBoxVector.some((x)=> x===true)){
        let newIndex = checkBoxVector.findIndex(isTrue)
        if(index === newIndex){
          setOpacity(1);
        }else{
          setOpacity(0.2);
        }
      }else{
        setOpacity(1);
      }
    },[checkBoxVector])

    const isTrue = (v) => v === true

    //Set true if Arrow head clicked, this is sent to the canvas object, where transformation will be handled
    const arrowHeadClicked = useRef(false);

    //Group Ref for Drag Manipulation
    //const image = useRef(null);

    //console.log("PGWH", width, height);

    useEffect(() => {
      setOrigin({ x: posX * stepSize, y: height - posY * stepSize });
    }, [posX, posY, height, stepSize]);

    useEffect(() => {
      setDimension({  width: magY, height: magX });
    }, [magX,magY]);


    const showCursor = (evt) => {
      const { offsetX, offsetY } = evt;

      const absWidth = origin.x + dimension.height; //dimension.height is used as canvas is flipped by 270 deg
      const absHeight = origin.y - dimension.width; //dimension.height is used as canvas is flipped by 270 deg

      if (
        Math.abs(offsetX - absWidth) <= stepSize &&
        Math.abs(offsetY - absHeight) <= stepSize
      ) {
        stage.current.container().style.cursor = "pointer";
        arrowHeadClicked.current = true;
      } else {
        stage.current.container().style.cursor = "move";
        arrowHeadClicked.current = false;
      }
    };

    const onMouseEnter = ({ evt }) => {
      if(readOnly){
        return;
      }
      showCursor(evt);
      evt.stopPropagation();
      setShowLabel(true);
    };

    const onMouseLeave = () => {
      if(readOnly){
        return;
      }
      if (stage && stage.current)
        stage.current.container().style.cursor = "default";
      setShowLabel(false);
    };

    const handleMouseDown = ({ evnt }) => {
      if(readOnly){
        return;
      }
      onVectorMouseDown({
        evnt,
        arrowHeadClicked: arrowHeadClicked.current,
        index,
      });
    };

    const onMouseClicked = (evnt) => {
      if(readOnly){
        return;
      }
      onVectorClicked({
        evnt,
        arrowHeadClicked: arrowHeadClicked.current,
        index,
      });
    };

    const onDragEndLocal = () => {
      if(readOnly){
        return;
      }
      if (groupRef.current)
        onDragEnd({ x: groupRef.current.x(), y: groupRef.current.y() });
    };

    const onDragStartLocal = () => {
      if(readOnly){
        return;
      }
      onDragStart({ index: index });
    };

    const { angleOffset, type, clockwise } = angleOptions;
    const angleBase =
      (Math.atan2(dimension.width, dimension.height) * 180) / Math.PI;
    let angle =
      angleBase > 0 ? angleBase - angleOffset : 360 + angleBase - angleOffset;
    angle = angle < 0 ? 360 + angle : angle;
    let angleSigned = angle > 180 ? angle - 360 : angle;
    let angleText = -angleSigned;
    if (type === 2) {
      angleSigned = angle;
      if (clockwise) {
        angleSigned = angle - 360;
      }
    }
    if (type !== 3) angleText = Math.abs(angleSigned);

    //const angleSigned = angle;// angle>180?angle-360:angle;

    //Imagine the text is on a point, of a line, drawn perpendicular to the vector, which passes through the mid point of the vector.
    const getLabelPoint = () => {
      //calculate the slope of the perpendicular line.
      //https://www.mathsisfun.com/algebra/line-equation-2points.html
      const x = dimension.height;
      const y = dimension.width;
      
      if(x === 0 && y === 0){
        return [x,y];
      }
      if((height / stepSize) <= 5) {
        const slope = -3 * (x / y);
        const perpLineAngle = Math.atan(slope);

        const xPoint1 = (x / 4) - 1.5 * (stepSize / 2) * Math.cos(perpLineAngle);
        const yPoint1 = (y / 4) - 1.5 * (stepSize / 2) * Math.sin(perpLineAngle);
        return [yPoint1, (xPoint1 / 4)];
      } else {
        const slope = -1 * (x / y);
        const perpLineAngle = Math.atan(slope);

        const xPoint1 = x / 2 - 1.5 * stepSize * Math.cos(perpLineAngle);
        const yPoint1 = y / 2 - 1.5 * stepSize * Math.sin(perpLineAngle);
        return [yPoint1, xPoint1];
      }
    };

    const [xPoint1, yPoint1] = getLabelPoint(); //[ dimension.width/2 + (1.5*stepSize),dimension.height/2]
    
    const Quad = getQuadrant(x,y,posX,posY,gridWidthUnit,gridHeightUnit);
    
    const boxMark = (quad, xory, rule=1) => {
      let posX1 = parseInt(posX);
      let posY1 = parseInt(posY);
      let gridWidthUnit1 = parseInt(gridWidthUnit);
      let gridHeightUnit1 = parseInt(gridHeightUnit);
      let realOrginx = posX1-(gridWidthUnit1/2); // Calculating Graph Origin for X
      let realOriginy = posY1-(gridHeightUnit1/2); // Calculating Graph Origin for Y
      let boxscale;
      if(quad == 1){
        boxscale = rule == 1 ? xory == "x" ? 0.6 : 0.75 : xory == "x" ? 0.8 : 0.8;
      }else if(quad == 2){
        boxscale = rule == 1 ? xory == "x" ? 0.6 : 0.75 : xory == "x" ? 0.8 : 0.8;
      }else if(quad == 3){
        boxscale = rule == 1 ? xory == "x" ? 0.7 : 0.7 : xory == "x" ? 0.8 : 0.7;
      }else if(quad == 4){
        boxscale = rule == 1 ? xory == "x" ? 0.6 : 0.7 : xory == "x" ? 0.8 : 0.7;
      }else{
        boxscale = rule == 1 ? xory == "x" ? 0.6 : 0.7 : xory == "x" ? 0.7 : 0.6;
      } 
      
      let boxoffset = boxOffset(xory, realOrginx, realOriginy, rule)
      let boxMark;
      if(rule == 1){
        boxMark = boxscale * (xory == "x" ? x - realOrginx : y-realOriginy)+boxoffset;
      }else{
        boxMark = boxscale * (xory == "x" ? x - realOrginx : y-realOriginy)+ boxoffset;
      }
      return boxMark;
    } 

    function boxOffset(xory, realOrginx, realOriginy, rule){
      if(rule == 1){
        if(xory == "x"){
          if((x-realOrginx)>=0){
            return -0.25;
          }else{
           return 0.25;
          }
       }else{
         if((y-realOriginy)>=0){
           return +0.5;
         }else{
          return -0.5;
         }
       }
      }else{
        if(xory == "x"){
          if((x-realOrginx)>=0){
            return 0.25;
          }else{
           return -0.25;
          }
       }else{
         if((y-realOriginy)>=0){
           return -0.5;
         }else{
          return 0.5;
         }
       }
      }
    }
    
    //Getting graphSize to Canvas Image Pixels for One Box Size
    let generateMultiplyFactorForLabel = (CPixel,gridSize) =>{
         let CPixel1 = parseInt(CPixel)
         let gridSize1 = parseInt(gridSize)

         return CPixel1/gridSize1;

    }
    
    let yBoxMark, xBoxMark, multiplyFactorX, multiplyFactorY;
    
    // Matching Total Number of Vectors for Label Rule Position
    if(Nvector<=2){
      yBoxMark= boxMark(Quad, "x", labelRule);
      xBoxMark= boxMark(Quad, "y", labelRule);
      multiplyFactorY = generateMultiplyFactorForLabel(width, gridWidthUnit) * 0.92; //Getting 0.X(X%) value for Pixel Adjustment in Canvas X axis
      multiplyFactorX = generateMultiplyFactorForLabel(height, gridHeightUnit) * 0.92; //Getting 0.Y(Y%) value for Pixel Adjustment in Canvas Y axis
      multiplyFactorY = (multiplyFactorY > 65) ? 60:multiplyFactorY;
      multiplyFactorX = (multiplyFactorX > 65) ? 60:multiplyFactorX; 
    }else{//More Than 2 Vectors Factor Assignment 
      if(labelRule > 2){
        yBoxMark= x;
        xBoxMark= y;
        multiplyFactorY = generateMultiplyFactorForLabel(width, gridWidthUnit) * 0.70;
        multiplyFactorX = generateMultiplyFactorForLabel(height, gridHeightUnit) * 0.70;
        multiplyFactorY = (multiplyFactorY > 65) ? 60:multiplyFactorY;
        multiplyFactorX = (multiplyFactorX > 65) ? 60:multiplyFactorX;
      }else{
        yBoxMark= boxMark(Quad, "x", labelRule);
        xBoxMark= boxMark(Quad, "y", labelRule);
        multiplyFactorY = generateMultiplyFactorForLabel(width, gridWidthUnit) * 0.92; //Getting 0.X(X%) value for Pixel Adjustment in Canvas X axis
        multiplyFactorX = generateMultiplyFactorForLabel(height, gridHeightUnit) * 0.92; //Getting 0.Y(Y%) value for Pixel Adjustment in Canvas Y axis
        multiplyFactorY = (multiplyFactorY > 65) ? 60:multiplyFactorY;
        multiplyFactorX = (multiplyFactorX > 65) ? 60:multiplyFactorX; 
      }
    }
    


    let angleTextPosX = 0;
    let angleTextPosY = 0;
    let angleRotation = 0;
    angleRotation =
      angleSigned > 0 ? 90 - angleOffset - angle : -(270 + angleOffset);
    if (type === 2) {
      if (!clockwise) angleRotation = -(angle + angleOffset - 90);
      //angleSigned>0?(90-angleOffset)-angle:-(270+angleOffset);
      else {
        angleRotation = -(270 + angleOffset); //angleSigned>0?(90-angleOffset)-angle:-(270+angleOffset);
      }
    }

    const angleOffsetOpposite =
      angleOffset >= 0 && angleOffset <= 180
        ? angleOffset + 45
        : angleOffset - 45;

    const argReducedAngleSize = (height / stepSize) > 7 ? 1 : 2;

    const signAngle = angleOffset > 0 ? -1 : -1;
    if (angle >= 0 && angle <= 180) {
      angleTextPosX =
        signAngle *
        -1.5 *
        (stepSize / argReducedAngleSize) *
        Math.cos((angleOffsetOpposite * Math.PI) / 180);
      angleTextPosY =
        signAngle *
        -1.5 *
        (stepSize / argReducedAngleSize) *
        Math.sin((angleOffsetOpposite * Math.PI) / 180);

        // console.log("angleTextPosY", signAngle ,
        //   -2 ,
        //   (stepSize / argReducedAngleSize) ,
        //   Math.cos((angleOffsetOpposite * Math.PI) / 180))
    } else if (angle > 180 && angle < 360) {
      angleTextPosX =
        signAngle *
        1.5 *
        (stepSize / argReducedAngleSize) *
        Math.cos((angleOffsetOpposite * Math.PI) / 180);
      angleTextPosY =
        signAngle *
        1.5 *
        (stepSize / argReducedAngleSize) *
        Math.sin((angleOffsetOpposite * Math.PI) / 180);
    }
    const arrowLength = dimension.height <= stepSize && dimension.width <= stepSize ? stepSize * 0.3 : 10;
    const arrowWidth = arrowLength;
    //console.log('dimension.height', height / stepSize)
    //console.log('dimension.width', width / stepSize)
    // console.log('Graph Origin', origin);
    //console.log('Graph Points', xPoint1, yPoint1);
    // console.log('Graph dimension', dimension);


    return (
      <React.Fragment>
        <Group
          onMouseLeave={onMouseLeave}
          x={origin.x}
          y={origin.y}
          height={dimension.height}
          width={dimension.width}
          rotation={-90}
          ref={groupRef}
          draggable={!readOnly && !arrowHeadClicked.current}
          onDragStart={onDragStartLocal}
          onDragEnd={onDragEndLocal}
          onTouchEnd={onMouseLeave}
          opacity={opacity}
        >
          {stepDeg && (dimension.width !== 0 || dimension.height !== 0 ) ? (
            <>
              <Line
                points={[0, 0, 0, 2 * stepSize]}
                stroke="black"
                strokeWidth={1}
                rotation={-angleOffset}
              />
              <Arc
                outerRadius={stepSize / argReducedAngleSize}
                stroke={color}
                strokeWidth={1}
                angle={Math.abs(angleSigned)}
                rotation={angleRotation}
                x={0}
                y={0}
              ></Arc>
              {/* <Text
                  text={
                    stepDeg
                      ? `${angleText.toFixed(0)}\xB0`
                      : `${angleText.toFixed(1)}\xB0`
                  }
                  x={angleTextPosX}
                  y={angleTextPosY}
                  rotation={90}
                ></Text> */}
              <Label
                x={angleTextPosX}
                y={angleTextPosY}
                opacity={1}
                rotation={90}
              >
                <Tag
                  fill={'#fff'}
                  pointerDirection={'center'}
                  pointerWidth={15}
                  pointerHeight={10}
                ></Tag>
                <Text
                  text={
                    stepDeg
                      ? `${angleText.toFixed(0)}\xB0`
                      : `${angleText.toFixed(1)}\xB0`
                  }
                  fill={color}
                  padding={2}
                  fontSize={11}
                ></Text>
              </Label>
            </>
          ) : null}
        
          {/* Subtracting the Height and Width a constant to make the arrow head sit flush with the graph lines,
                        since it seems arrows go beyond the dimensions in Konova if the stroke width is greater than 1 */}
          <Arrow1
            dimension={dimension}
            stroke={color}
            strokeWidth={strokeWidth}
            pointerWidth={arrowWidth}
            pointerLength={arrowLength}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onMouseClicked}
            onMouseDown={handleMouseDown}
            stepSize={stepSize}
            showComponents={showComponents}
            onArrowClicked={onArrowClicked}
            index={index}
            initializedIndex={initializedIndex}
            opacity={opacity}
            clickedVector={clickedVector}
          />
          {(latexImage && showLabel) || (dimension.height === 0 && dimension.width === 0) ? (
            <Image
              x={xPoint1===0 ? xPoint1 : (dimension.width === 0 ? ((xBoxMark * multiplyFactorX) + latexImage.height) : (xBoxMark * multiplyFactorX))}
              y={yPoint1 ===0 ? yPoint1: (dimension.height === 0 ? ((yBoxMark * multiplyFactorY) + latexImage.width) : (yBoxMark * multiplyFactorY))}
              fill="#F5F5F5"
              image={latexImage}
              rotation={90}
              height={latexImage.height}
              width={latexImage.width > 100 ? latexImage.width - 27 : latexImage.width}
            />
          ) : null}
          {(latexImage && (x === 0 && y === 0)) && (dimension.height === 0 && dimension.width === 0) ? (
            <Circle
                x={xPoint1}
                y={yPoint1}
                radius={stepSize > 70 ? stepSize / 14 : stepSize / 4}
                fill="#8F8F8F"
              />
          ) : null}
        </Group>
      </React.Fragment>
    );
  }
);

const areEqualCheck = (prevProps, nextProps) => {
  if(prevProps.ComponentGuid == nextProps.ComponentGuid) {
    return true;
  } else {
    // console.log('CURRENT VIEW NEEDS RE-RENDER =>', prevProps, nextProps)
    return false;
  }
};

export default React.memo(Vector, areEqualCheck);
